import { Record } from 'immutable';

const {
    POST_ALLOCATE_CREDIT_REQUEST,
    POST_ALLOCATE_CREDIT_SUCCESS,
    POST_ALLOCATE_CREDIT_FAILURE,
} = require('./companyActions').constants;

const InitialState = Record({
    error: null,
    isFetching: false,
});

const initialState = new InitialState();

/**
* ## galleryReducer function
* @param {Object} state - initialState
* @param {Object} action - type and payload
*/
export default function companyReducer(state = initialState, { payload, type }) {
    if (!(state instanceof InitialState)) return initialState.mergeDeep(state);

    switch (type) {
    case POST_ALLOCATE_CREDIT_REQUEST:
        return state.set('isFetching', true)
            .set('error', null);
    case POST_ALLOCATE_CREDIT_SUCCESS:
        return state.set('isFetching', false);
    case POST_ALLOCATE_CREDIT_FAILURE:
        return state.set('isFetching', false)
            .set('error', payload);
    default:
        return state;
    }
}
